const Mashing = ({ className }) => {
  return (
    <div className={`round-icon ${className}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
        <g>
          <g>
            <path d="M62.76,121.4l-5.22-4.31,2.15-2.61A19.85,19.85,0,0,0,44.37,82a13.19,13.19,0,0,0-4.21.44h0L36,76.51l1.37-.37a26.64,26.64,0,0,1,27.52,42.65Z" />
            <path d="M27,122.29l-2.28-2.5a26.63,26.63,0,0,1,1.83-37.72l.81-.73,2.94,6.51h0c-4.17,3.77-5.77,8.39-5.77,14a19.81,19.81,0,0,0,5.19,13.38l2.28,2.5Z" />
            <path d="M50.28,103.39a5.34,5.34,0,1,1-9.4-3.45L31.15,77.28,44.83,98.06h.11A5.34,5.34,0,0,1,50.28,103.39Z" />
            <path d="M148.23,51.44c-2.58-4.34-5.55-6.43-8.84-6.22a7.45,7.45,0,0,0-1.18.18V28.15l-1.83-1A102,102,0,0,0,108.54,17a17.71,17.71,0,0,0-5.06-11.55C99.84,1.84,94.68.1,88.2.21,81.55.34,76.42,2.28,73,6a16.42,16.42,0,0,0-4.3,10.26A116.66,116.66,0,0,0,34.21,27.16l-1.83,1v18.1a12.92,12.92,0,0,0-4.1-1c-4.33-.33-8.54,1.53-12.53,5.51l-2.47,2.47,4.94,4.94,2.46-2.47c2.47-2.47,4.83-3.64,7-3.49a7.79,7.79,0,0,1,4.68,2.35v5.06a43.65,43.65,0,0,0,0,84.27v6.22H138.21v-96a5.51,5.51,0,0,1,1.56-1.87s.94.27,2.46,2.83L144,58l6-3.57ZM78.06,10.75c2.13-2.27,5.58-3.47,10.26-3.56,5.52-.09,9.41,1.49,11.53,4.74a11,11,0,0,1,1.48,3.55c0,.09,0,.17,0,.25a109.8,109.8,0,0,0-25.58-.4A9.29,9.29,0,0,1,78.06,10.75Zm-70.95,91a36.68,36.68,0,1,1,36.68,36.68A36.72,36.72,0,0,1,7.11,101.74Zm124.12,41.38H57.72a43.65,43.65,0,0,0-18.37-84.8V32.41c9.1-4.26,50.57-21.27,91.88-.07Z" />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Mashing;
